<template>
  <div class="list_zones pt-3">
  	<b-container fluid>
      <p v-if='!$distribution.zones' class="text-center mt-3">
        Não foi encontrada distribuição para o hotel selecionado.
      </p>
      <b-row v-for="(zone, idx) in $distribution.zones"
        :key="idx"
        v-on:click="$emit('go_to', {name: 'list_rooms', params: {cod_dist_zone: zone.cod_distribution_zone, dist_zone: zone, search_hotel: $distribution.search_hotel, search_bloco: $distribution.search_bloco, search_piso: $distribution.search_piso, search_n_quarto: $distribution.search_n_quarto}})"
        class="bg-grey-light pb-3 mb-3 border cursor-pointer">
  			<b-col cols="12" class="p-0">
		  		<hr class="mt-0 pt-1 mb-1">
  				<b-container>
            <div class="progress-wrapper font-size-0">
  						<div class="d-inline-block" v-for="(room, idx) in zone.rooms" :key="room.cod_distribution_room" :style="'width:' +(100/zone.rooms.length)+ '%'" :class="get_progress_class(room, zone)"></div>
  					</div>
  					<div class="mt-3">
  						<h4 class="font-weight-bold text-center color-green">{{trans['AREA']}} {{zone.distribution_num}}</h4>
  					</div>
            <table class="table table-striped mt-3">
              <thead class="bg-grey-dark text-white">
                <tr>
                  <th scope="col">{{trans['COLABORADOR_A']}}</th>
                  <th scope="col">{{trans['QTD_QUARTOS']}}</th>
                  <th scope="col">{{trans['TEMPO_TOTAL_MIN']}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {{zone.pessoa.nome}}<span class="ml-2 fa fa-chess-queen"></span>
                  </td>
                  <td>
                    {{totals_dist_data[zone.cod_distribution_zone].z_c_rooms}}
                  </td>
                  <td>
                    {{totals_dist_data[zone.cod_distribution_zone].z_c_time}}
                  </td>
                </tr>
                <tr v-for="(t, idx) in totals_dist_data[zone.cod_distribution_zone].persons" :key="idx">
                  <td>
                    {{t.nome}}
                  </td>
                  <td>
                    <span class="text-muted">{{t.c_rooms}}</span>
                  </td>
                  <td>
                    <span class="text-muted">{{t.c_time}}</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <!-- <tr>
                  <th scope="row">
                    Total
                  </th>
                  <th scope="row">
                    {{totals_dist_data[zone.cod_distribution_zone].z_c_rooms}}
                  </th>
                  <th scope="row">
                    {{totals_dist_data[zone.cod_distribution_zone].z_c_time}}
                  </th>
                </tr> -->
              </tfoot>
            </table>
				</b-container>
			</b-col>
		</b-row>
  	</b-container>
  </div>
</template>

<script>

export default {
  name: 'list_zones',
  data() {
  	return {
  		loading: false,
  		// rooms_status: JSON.parse(localStorage.getItem('rooms_status')),
  	}
  },
  methods: {
    send_data(items) {
    /*clearTimeout(this.req_timer);*/
      if(items.length > 0) {
        this.$http.post('housekeeping/update_rooms?token=' +this.$distribution.person.token,
          {
            rooms: items
          },
          {
            before(request) {
          }
        })
        .then(resp => {
          for(var r of resp.body.rooms) {
            for(var z of this.$distribution.zones) {
              var r_idx = z.rooms.findIndex((item, idx) => item.cod_distribution_room == r.cod_distribution_room);
              if(r_idx !== -1) {
                this.$set(z.rooms, r_idx, r);
              }
            }
          }
        }, resp => {

        }).then(resp => {
          /*this.req_timer = setTimeout(function() {
            that.send_data([]);
          }, 10000)*/
        });
      }
    },
  },
  computed: {
    totals_dist_data: function() {
      var totals = {};
      for(let z of this.$distribution.zones) {
        totals[z.cod_distribution_zone] = {z_c_time: 0, z_c_rooms: 0, persons: {}};
        for(let r of z.rooms) {
          if(r.cod_pessoa !== null) {
            if(typeof totals[z.cod_distribution_zone].persons[r.cod_pessoa] === 'undefined') {
              totals[z.cod_distribution_zone].persons[r.cod_pessoa] = {c_rooms: 0, c_time: 0, nome: r.pessoa_nome};
            }
            totals[z.cod_distribution_zone].persons[r.cod_pessoa].c_rooms += 1;
            totals[z.cod_distribution_zone].persons[r.cod_pessoa].c_time += parseInt(r.estimated_mins_duration);
          }
          totals[z.cod_distribution_zone].z_c_time += parseInt(r.estimated_mins_duration);
          totals[z.cod_distribution_zone].z_c_rooms += 1;
        }
      }
      return totals;
    },
    colaborators: function() {

    }
  	/*zones_data: function() {
  		if(typeof this.zones === 'undefined') {
  			return this.data.zones;
  		}
  		return this.zones;
  	},*/
  },
  watch: {

  },
  created: function() {
    /*console.log(this.$distribution.zones);*/
  }
}
</script>
<style scoped>
	.progress-wrapper > div {
		height: 6px;
	}
</style>